<template></template>
<script>
import { ref, inject } from 'vue';
import { isJson } from '../../js/func.general';
export default {
    name: 'FetchData',
    props: {
        'eventSource': Object
    },
    setup(props, ctx) {
        //injections
        const changeError = inject('changeError');
        const changeLayer = inject('changeLayer');
        const changeSessionEndStatus= inject('changeSessionEndStatus');
        const closeSession= inject('closeSession');

        //variables
        const errorCode = ref('');
        const errorText = ref('');
        const errorCritical = ref(false);

        async function fetchData(url, formData, task) {
            try {
                const response = await fetch(`php/${url}`, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    try {
                        const data = await response.text();
                        if (isJson(data)) {
                            const dataBack = JSON.parse(data);
                            if (dataBack && !dataBack.processResponse) {
                                errorCode.value = dataBack.errorCode;
                                errorText.value = dataBack.error;
                                if (dataBack.critical && dataBack.critical === true) {
                                    errorCritical.value = true;
                                } else {
                                    errorCritical.value = false;
                                }
                                throw new Error();
                            }
                            return dataBack;
                        } else {
                            errorCode.value = 'main';
                            errorText.value = data;
                            errorCritical.value = true;
                            throw new Error();
                        }
                    } catch {
                        throw new Error();
                    }
                } else {
                    errorCode.value = 'main';
                    errorText.value =  `${response.status}: url: ${response.url} - ${response.statusText}`;
                    errorCritical.value = true;
                    throw new Error();
                }
            } catch {
                handleFetchError(task);
                return {processResponse : false};
            };
        }

        function handleFetchError(task) {
            switch(errorCode.value) {
                case 'noSession':
                    changeLayer('session', true); 
                    window.scrollTo(0,0);
                    if (props.eventSource) {
                        closeSession();
                    }
                    changeSessionEndStatus('noSession');
                    break;
                default: 
                    if (errorCritical.value === true) {
                        changeLayer('error', true);
                    } else {
                        changeLayer('error', false);
                    }
                    changeError(errorText.value, task, 'Es gab ein Problem beim Verarbeiten der Daten');
            }
        }


        return {
            fetchData, 
            errorCritical
        }

    }
}
</script>